<template>
  <div
    v-if="showProgress"
    class="overlay"
  >
    <div class="overlay-contents">
      <span class="upload-text upload-blink">
        {{ uploadMessage }}
      </span>
      <br><br>
      <div class="progress-bar-border">
        <b-progress-bar
          max="100"
          class="progress-bar-upload"
          :value="uploadPercentage"
          animated
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BProgressBar } from 'bootstrap-vue'

export default {
  components: {
    BProgressBar,
  },
  props: {
    uploadPercentage: {
      type: Number,
      default: 0,
    },
    uploadMessage: {
      type: String,
      default: 'Loading...',
    },
    showProgress: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style scoped lang="scss" >
 @import "src/@core/scss/base/components/_variables.scss";

.progress-bar-upload {
  height: $progress-height;
  text-align: center;
  background-color: $gray-400;
  color: $white;
}
.progress-bar-border{
  border: $border-width solid $gray-400;
}
.overlay {
  position: fixed;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba($white, 0.45);
  z-index: 9999;
  text-align: center;
  justify-content: center;
  display: flex;
}
.overlay-contents {
  position: absolute;
  align-items: center;
  box-sizing: border-box;
  width: 45%;
  color: $black;
  text-align: center;
  font-size: $h3-font-size;
}
.upload-text {
  animation:fadeIn 2s ease infinite;
  color: $black;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .overlay-contents{
    width: 90%;
  }
}
</style>
